import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {environment} from '../../../../environments/environment';
import {HttpService} from '../../../services/http.service';
import {GridService} from '../../../services/grid.service';

@Component({
  selector: 'app-ai-fine-tune-gpt-actions',
  templateUrl: './ai-fine-tune-gpt-actions.component.html',
  styleUrls: ['./ai-fine-tune-gpt-actions.component.scss']
})
export class AiFineTuneGptActionsComponent implements OnInit {
  private params!: ICellRendererParams;
  public value: string = ''
  constructor(
    private httpService: HttpService,
    private gridService: GridService
  ) { }

  ngOnInit(): void {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.value = this.params.value;
  }

  refresh(params: ICellRendererParams): boolean {
    return true;
  }

  onPush() {
    this.httpService.post(environment.API_PATH + `/ai/pushToLearnFromGptResults/${this.params.data._id}`, {}).subscribe(res => {
      this.gridService.aiLearGridEvent.next(true);
      this.gridService.aiFineTuneGptCompleteEvent.next(true);
    });
  }
  onDelete() {
    if (confirm('Are you sure?')) {
      this.httpService.post(environment.API_PATH + `/ai/deleteGptResultsData/${this.params.data._id}`, {}).subscribe(res => {
        this.gridService.aiFineTuneGptCompleteEvent.next(true);
      });
    }
  }
}
